enum BASIC {
  SET_TOKEN,
  SET_USER_INFO,
  SET_SMS_SEND_TIME,
  LOGOUT,
  SET_SOURCE,
}

export default BASIC
